import React from 'react';
import AgencyListModule from '../modules/AgencyListModule.js';
import './Box.css';

const AgencyListBox = ({ user, isSmallScreen }) => {

    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>
            
            <h4></h4>

            <AgencyListModule 
                user={user}
                isSmallScreen={isSmallScreen}
            />
        </div>
    );
};

export default AgencyListBox; 